var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.25C1.66848 3.25 1.35054 3.1183 1.11612 2.88388C0.881696 2.64946 0.75 2.33152 0.75 2C0.75 1.66848 0.881696 1.35054 1.11612 1.11612C1.35054 0.881696 1.66848 0.75 2 0.75C2.33152 0.75 2.64946 0.881696 2.88388 1.11612C3.1183 1.35054 3.25 1.66848 3.25 2C3.25 2.33152 3.1183 2.64946 2.88388 2.88388C2.64946 3.1183 2.33152 3.25 2 3.25ZM2 7.25C1.66848 7.25 1.35054 7.1183 1.11612 6.88388C0.881696 6.64946 0.75 6.33152 0.75 6C0.75 5.66848 0.881696 5.35054 1.11612 5.11612C1.35054 4.8817 1.66848 4.75 2 4.75C2.33152 4.75 2.64946 4.8817 2.88388 5.11612C3.1183 5.35054 3.25 5.66848 3.25 6C3.25 6.33152 3.1183 6.64946 2.88388 6.88388C2.64946 7.1183 2.33152 7.25 2 7.25ZM0.75 10C0.75 10.3315 0.881696 10.6495 1.11612 10.8839C1.35054 11.1183 1.66848 11.25 2 11.25C2.33152 11.25 2.64946 11.1183 2.88388 10.8839C3.1183 10.6495 3.25 10.3315 3.25 10C3.25 9.66848 3.1183 9.35054 2.88388 9.11612C2.64946 8.8817 2.33152 8.75 2 8.75C1.66848 8.75 1.35054 8.8817 1.11612 9.11612C0.881696 9.35054 0.75 9.66848 0.75 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMoreIcon);
export default __webpack_public_path__ + "static/media/profileMoreIcon.af4f02ba98b58a3d70e91a4ac0999fb7.svg";
export { ForwardRef as ReactComponent };